import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white p-4 mt-4">
      <div className="container mx-auto text-center">
        &copy; 2024 eCard Platform by Bilda Studio. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;